export default class ColorFactory {

    isBlackOrWhite(color) {
        return color.name === 'white' || color.name === 'black'
    }

    createColorObject(colorFamily, shade) {
        if(colorFamily === 'white') {
            return this.createFixedColor(colorFamily, '#FFFFFF')
        } else if(colorFamily === 'black') {
            return this.createFixedColor(colorFamily, '#000000')
        } else if(colorFamily === 'transparent') {
            return this.createFixedColor(colorFamily, null)
        }

        if(!shade) {
            shade = '500'
        }

        const hexValue = webase.utils.color.getHexValue(colorFamily, shade)

        return {
            name: colorFamily,
            shade: shade,
            hexValue: hexValue
        }
    }

    createFixedColor(colorName, hexValue) {
        return {
            name: colorName,
            shade: null,
            hexValue: hexValue
        }
    }
}